import React from "react";
import { Link, location, useLocation } from 'react-router-dom';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import useUserAuth from "../../hook/useUserAuth";
import useGlobalStatus from '../../hook/useGlobalStatus';
import theme from '../../theme';

import { PRODUCT_NAME } from '../../constants/global';

import UserProfile from "./UserProfile";
import HelpModalIcon from "./HelpModalIcon";
import logo from '../../Logo.svg';

import { AppBarStyle, ToolbarStyle } from "./topbarStyle";
import { MenuOutlinedIcon } from "../customStyles/images";


const Topbar = (props) => {
  const { mobileOpen, setMobileOpen } = useGlobalStatus();
  const theme = useTheme();
  const isMoblie = useMediaQuery(theme.breakpoints.down('lg'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  const toggleDrawer = (newOpen) => () => {
    setMobileOpen(newOpen);
  };

  if (isMoblie) {
    return (
      <Box>
        <AppBarStyle
          id="appbar"
          position="fixed"
          isdesktop={isDesktop.toString()}
          sx={{ zIndex: 1000 }}
        >
          <Toolbar sx={{ minHeight: '64px' }}>
            <Box
              sx={{
                position: 'absolute',
                left: 0,
              }}
            >
              <MenuOutlinedIcon
                onClick={toggleDrawer(!mobileOpen)}
                sx={{ color: theme.palette.primary.main }}
              />
            </Box>

            <Box sx={{ mx: 'auto' }}>
              <Link to="/">
                <img src={logo} alt={PRODUCT_NAME} style={{ width: '200px' }} />
              </Link>
            </Box>
          </Toolbar>
        </AppBarStyle>
      </Box>
    )
  }

  return (
    <Box>
      <AppBarStyle
        component='nav'
        isdesktop={isDesktop.toString()}
        sx={{ zIndex: 1000 }}
      >
        <Toolbar style={ToolbarStyle}>
          <Link to="/">
            <Stack>
              <img src={logo} alt={PRODUCT_NAME} style={{ width: '200px' }} />
            </Stack>
          </Link>

          <Stack variant='center-center'>
            {/* <StageListItem color={mainColor}>
              測試版
            </StageListItem> */}

            {/* <Box mr={1}>
              <HelpModalIcon variant="desktop" />
            </Box> */}

            <UserProfile
              isDesktop={isDesktop}
              isMoblie={isMoblie}
            />
          </Stack>

        </Toolbar>
      </AppBarStyle>
    </Box>
  )
}

export default Topbar;
